export default {
  namespaced: true,
  state: {
    page: 1,
    perPage: 12,
    totalEntities: 0,
  },
  mutations: {
    setPage(state: any, page: number) {
      state.page = page;
    },
    setPerPage(state: any, perPage: number) {
      state.perPage = perPage;
    },
    setTotalEntities(state: any, totalEntities: number) {
      state.totalEntities = totalEntities;
    }
  },
  getters: {
    totalPages(state: any) {
      return Math.ceil(state.totalEntities / state.perPage);
    }
  }
}